import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { featureEnabled } from 'helpers/ToggleBot';
import { putLead } from 'actions/landlordLeadsActions';
import { getTenant } from 'actions/landlordTenantsActions';
import CheckboxNormal from 'components/ui/CheckboxNormal';
import { getTranslatedString } from 'helpers/i18n';

const StyledBody = styled.div`
  margin: 15px 15px 25px;
`;

const LegalNoticesOptIn = ({ getTenant, tenantDetails, putLead, tenantLegalDocumentsCheckbox }) => {
  const [checked, setChecked] = useState(tenantDetails.digital_legal_documents);

  const handleChange = (e) => {
    const isChecked = e.target.checked;
    setChecked(isChecked);
    setTimeout(() => {
      putLead(tenantDetails.lead_id, { digital_legal_documents: isChecked });
      getTenant(tenantDetails.id);
    }, 100);
  };

  if (!tenantLegalDocumentsCheckbox) return null;

  return (
    <StyledBody>
      <CheckboxNormal
        name="digital_legal_documents"
        value={checked}
        checked={checked}
        onChange={handleChange}
      >
        {getTranslatedString('landlordPortal.tenantOptInOptOut.legalNoticesSignedAddendum')}
      </CheckboxNormal>
    </StyledBody>
  );
};

const mapStateToProps = (store) => {
  return {
    /* In Nova Scotia, landlords need a physical signature opt-in to
     * send legal notices to residents. In this case, we allow landlords to opt-in
     * the resident to legal notices using the landlord portal.
     *
     * Agent can only opt-in resident if resident's property is assigned to agent.
     */
    tenantLegalDocumentsCheckbox:
      featureEnabled('legal_documents_as_notices') &&
      !!store.companyDetails.companyPreferences.enable_tenant_legal_notices &&
      !!store.landlordTenants.tenantDetails.in_nova_scotia &&
      store.landlordProperties.properties
        .map((p) => p.value)
        .includes(store.landlordTenants.tenantDetails.lease.property_id),
  };
};

LegalNoticesOptIn.propTypes = {
  putLead: PropTypes.func.isRequired,
  getTenant: PropTypes.func.isRequired,
  tenantLegalDocumentsCheckbox: PropTypes.bool.isRequired,
  tenantDetails: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, { putLead, getTenant })(LegalNoticesOptIn);
